export const pattern = {
  replaceTextPattern: /\D/g,
  replaceSpacePattern: /\s/g,
}

/**
   * Replace all spaces
   * @param value a string will cleared
   * @returns removed value
   */
export const removeAllSpaces = value => value.replace(pattern.replaceSpacePattern, '')

/**
   * Replace all Text for onlyDigit
   * @param value a string will cleared
   * @returns removed value
   */
export const removeAllChars = value => value?.replace(pattern.replaceTextPattern, '')

/**
   * substr to limit character
   * @param value a string will cleared
   * @returns removed value
   */
export const characterCountLimitter = ({ value = '', limit = 11 }) => `${value}`.substr(0, limit)

/**
   * Removes text in a string, using a regular expression or search string.
   * @param value a string will cleared
   * @param removePattern A string containing the text to remove for every
   * @returns removed value
   */
export const removeAll = (value, removePattern) => value.replace(removePattern, '')
